import type { Router } from 'vue-router';
import { isNavigationFailure } from 'vue-router';
import { useKeepAliveStore } from '@shared/store';

export function createPageKeepAliveRouterGuard(router: Router) {
  router.afterEach(async (to, _, failure) => {
    const keepAliveStore = useKeepAliveStore();

    if (isNavigationFailure(failure)) {
      console.error('failed navigation', failure);
    }
    // 在这里设置需要缓存的组件名称
    const componentName = to.matched.find((item) => item.name == to.name)?.components?.default.name;
    // 判断当前页面是否开启缓存，如果开启，则将当前页面的 componentName 信息存入 keep-alive 全局状态
    if (to.meta?.keepAlive) {
      // 需要缓存的组件
      if (componentName) {
        keepAliveStore.add(componentName);
      } else {
        console.warn(`${to.fullPath} 页面组件的 keepAlive 为 true 但未设置组件名，会导致缓存失效，请检查。`);
      }
    } else {
      // 不需要缓存的组件
      if (componentName) {
        keepAliveStore.remove(componentName);
      }
    }
  });
}
